import { render, staticRenderFns } from "./SystemDocument.vue?vue&type=template&id=1c4879ed"
import script from "./SystemDocument.vue?vue&type=script&lang=js"
export * from "./SystemDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports